import { Controller } from "stimulus"

export default class extends Controller {
  toggleInviteForm(event) {
    const element = event.target.closest('button')
    const { distributorId, hide } = element.dataset
    const inviteUserForm = document.getElementById(`distributor_${distributorId}_new_manager`);
    inviteUserForm.classList.toggle('d-none', hide);
  }

  toggleForm({ target }) {
    const hide = target.dataset.hide
    const newDistributorForm = document.getElementById('new_user');
    newDistributorForm.classList.toggle('d-none', hide);
  }
}
